export const userInfoReducer = (state = {}, action) => {
    switch (action.type) {
        case "SET_USER_INFO":
            return action.payload;
        case "CLEAR_USER_INFO":
            return {};
        default:
            return state;
    }
};
